import React from 'react';

export type AppName = 'cad' | 'first-responder';

const AppNameContext = React.createContext<AppName>('cad');

export function AppNameProvider(props: { appName: AppName; children: React.ReactNode }) {
    return (
        <AppNameContext.Provider value={props.appName}>{props.children}</AppNameContext.Provider>
    );
}

export function useAppName(): AppName {
    return React.useContext(AppNameContext);
}

export function getAppName(): AppName {
    return process.env.APP_NAME as AppName;
}
